<header class="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-cd-outline">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">
      <!-- Logo -->
      <a routerLink="/" class="flex items-center gap-2">
        <span class="material-symbols-outlined text-cd-primary text-2xl">forum</span>
        <span class="text-lg font-bold text-cd-on-surface">ChatDigest</span>
      </a>

      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center gap-8">
        <a routerLink="/" fragment="features"
           class="text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          Features
        </a>
        <a routerLink="/pricing" routerLinkActive="text-cd-primary"
           class="text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          Pricing
        </a>
        <a routerLink="/about" routerLinkActive="text-cd-primary"
           class="text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          About
        </a>
        <a routerLink="/faq" routerLinkActive="text-cd-primary"
           class="text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          FAQ
        </a>
      </nav>

      <!-- Desktop CTA -->
      <div class="hidden md:flex items-center gap-3">
        <a routerLink="/sign-in"
           class="text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          Sign In
        </a>
        <a routerLink="/sign-in"
           class="px-4 py-2 bg-cd-primary text-cd-on-primary rounded-cd-lg text-sm font-medium hover:bg-cd-primary-hover transition-colors flex items-center gap-1">
          Get Started
          <span class="material-symbols-outlined text-base">arrow_forward</span>
        </a>
      </div>

      <!-- Mobile Hamburger -->
      <button (click)="toggleMobileMenu()"
              class="md:hidden p-2 text-cd-on-surface-var hover:text-cd-on-surface">
        <span class="material-symbols-outlined text-2xl">
          {{ mobileMenuOpen ? 'close' : 'menu' }}
        </span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu Dropdown -->
  @if (mobileMenuOpen) {
    <div class="md:hidden border-t border-cd-outline bg-white">
      <div class="px-4 py-3 space-y-1">
        <a routerLink="/" fragment="features" (click)="toggleMobileMenu()"
           class="block px-3 py-2 rounded-cd-md text-sm font-medium text-cd-on-surface-var hover:bg-cd-surface hover:text-cd-on-surface transition-colors">
          Features
        </a>
        <a routerLink="/pricing" (click)="toggleMobileMenu()"
           class="block px-3 py-2 rounded-cd-md text-sm font-medium text-cd-on-surface-var hover:bg-cd-surface hover:text-cd-on-surface transition-colors">
          Pricing
        </a>
        <a routerLink="/about" (click)="toggleMobileMenu()"
           class="block px-3 py-2 rounded-cd-md text-sm font-medium text-cd-on-surface-var hover:bg-cd-surface hover:text-cd-on-surface transition-colors">
          About
        </a>
        <a routerLink="/faq" (click)="toggleMobileMenu()"
           class="block px-3 py-2 rounded-cd-md text-sm font-medium text-cd-on-surface-var hover:bg-cd-surface hover:text-cd-on-surface transition-colors">
          FAQ
        </a>
      </div>
      <div class="border-t border-cd-outline px-4 py-3 space-y-2">
        <a routerLink="/sign-in" (click)="toggleMobileMenu()"
           class="block px-3 py-2 text-sm font-medium text-cd-on-surface-var hover:text-cd-on-surface transition-colors">
          Sign In
        </a>
        <a routerLink="/sign-in" (click)="toggleMobileMenu()"
           class="block w-full text-center px-4 py-2 bg-cd-primary text-cd-on-primary rounded-cd-lg text-sm font-medium hover:bg-cd-primary-hover transition-colors">
          Get Started
        </a>
      </div>
    </div>
  }
</header>
